import request from '@/utils/request'

export function search(pageData, searchData) {
    return request({
        url: '/v2/sec/contractList/contractSearch',
        method: 'post',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data: {
            pageData,
            searchData
        }
    })
}

export function today() {
    var date = new Date()
    return date
}
export function lastMonth() {
    var date = new Date()
    var monthOfYear = date.getMonth()
    date.setMonth(monthOfYear - 3)
    return date
}